export default class TipoAgendamentoModel {
  constructor({
    id = 0,
    nome = '',
    descricao = null,
    filaId = 0,
    tempoDeAtendimento = 0,

  } = {}) {
    this.id = id
    this.nome = nome
    this.descricao = descricao
    this.filaId = filaId
    this.tempoDeAtendimento = tempoDeAtendimento
  }
}
